module.exports = __webpack_public_path__ + "media/images/yardage_mark_2-488d3ec61508ea28d6c37ad50a74c4d6.png";